document.addEventListener("DOMContentLoaded", function() {
    const menu__intersecter = document.getElementById("main__menu__intersection");
    const options = { rootMargin: "0px" };
    const menu = document.getElementById("main__menu__startpage");
    const header = document.getElementById("header");
    const slider = document.getElementById("slider");

    if(menu__intersecter) {
        const menu__intersecter_Observer = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.boundingClientRect.top > 0) {
                    console.log('top1');
                    
                    menu.classList.remove("fixed");
                    menu.classList.remove("fixed-top");
                    header.classList.remove("fixed-top");
                    slider.classList.remove("fixed-top");
                } else if(!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    console.log("top2");
                    menu.classList.remove("fixed");
                    menu.classList.add("fixed-top");
                    header.classList.add("fixed-top");
                    slider.classList.add("fixed-top");
                } else {
                    console.log("top3");
                    console.log(entry.boundingClientRect.top);
                    console.log(entry);
                    const scrollableHeight =
                            document.documentElement.scrollHeight -
                            window.innerHeight;
                    console.log('scrollable Height');
                    console.log(scrollableHeight);
                    console.log(window.pageYOffset);
                    console.log(window.scrollY >= scrollableHeight);

                    menu.classList.remove("fixed-top");
                    menu.classList.add("fixed");
                    header.classList.remove("fixed-top");
                    slider.classList.remove("fixed-top");
                }
            });
        },
        options);

        menu__intersecter_Observer.observe(menu__intersecter);
    }
});
